import { createFileRoute } from "@tanstack/react-router";
import { TemplatesPage } from "@/features/templates/templates-page";

/** Pro: saved checklist / budget / timeline templates. */
export const Route = createFileRoute("/app/templates")({ component: TemplatesPage });
